var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home---Multiple-(Empty-States)",
    transform: "translate(-27.000000, -793.000000)",
    fill: "#4A5866",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar",
    transform: "translate(0.000000, 86.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,707 C31.48,707 27,711.48 27,717 C27,722.52 31.48,727 37,727 C42.52,727 47,722.52 47,717 C47,711.48 42.52,707 37,707 Z M41,718 L38,718 L38,721 C38,721.55 37.55,722 37,722 C36.45,722 36,721.55 36,721 L36,718 L33,718 C32.45,718 32,717.55 32,717 C32,716.45 32.45,716 33,716 L36,716 L36,713 C36,712.45 36.45,712 37,712 C37.55,712 38,712.45 38,713 L38,716 L41,716 C41.55,716 42,716.45 42,717 C42,717.55 41.55,718 41,718 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGrey);
export default __webpack_public_path__ + "static/media/add-grey.7fcbd0de7ef0ed693d59eceaa8cb0190.svg";
export { ForwardRef as ReactComponent };